// i18n area 'storage' — locale no-NO (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/storage.no-NO.meta.json.
import type { enUS } from './storage'

export const noNO: typeof enUS = {
  storage: {
    pools: {
      title: 'Storage',
      createTitle: 'Opprett storage',
      path: 'Sti',
      pathHint: 'Absolutt sti under en tillatt rot (default /var/lib/tvirt/pools/)',
      shared: 'Delt storage',
      sharedChip: 'delt',
      sharedVerifiedChip: 'delt · verifisert',
      sharedVerifiedTooltip: 'Deling verifisert: kryss-sondene bekrefter at hvert medlem ser dataene de andre skriver.',
      sharedDisputedChip: 'delt · IKKE verifisert',
      sharedDisputedTooltip: 'Deling IKKE verifisert',
      sharedDisputedPair: '{observer} ser ikke dataene skrevet av {writer}',
      sharedHint: 'Nettverksshare montert lokalt på samme sti på hvert medlem — forutsetning for live-migrering (deklarativt).',
      sharedDanger: 'FARE — TVirt TROR på dette flagget: slår du det på antar hvert medlem å se DE SAMME bytene på denne stien. På en mappe som IKKE er en virkelig delt share (NFS/CIFS/kluster-filsystem) er resultatet korrupsjon og datatap ved første migrering eller første HA-omstart på en annen node. Slå det på bare hvis stien er en share montert identisk på hver node.',
      type: 'Type',
      capacity: 'Kapasitet',
      provisioned: 'Allokert',
      provisionedOvercommit: 'Potensiell forpliktelse utover kapasiteten: thin-volumene kan vokse opptil {n} GiB.',
      phase: { ready: 'Klar', degraded: 'Degradert', error: 'Feil' },
      tabConfig: 'Konfigurasjon',
      tabCapacity: 'Kapasitet og status',
      cardIdentity: 'Identitet',
      cardPlacement: 'Plassering',
      cardConnection: 'Tilkobling',
      usedReal: 'Reell bruk',
      capacityUnknown: 'Noden har ikke rapportert kapasiteten til denne poolen ennå — her diktes det ikke opp tall',
      overcommitHint: 'Forpliktelse utover kapasiteten: legitimt på thin-pooler, hold øye med den reelle bruken',
      supportedContent: 'Støttet innhold',
      content: {
        disks: 'Disker',
        catalogFiles: 'Katalogfiler',
        backups: 'Backuper',
        appVolumes: 'App-volumer'
      },
      defaultDiskFormat: 'Default diskformat',
      reserveGiB: 'Reservert ledig plass (GiB)',
      available: 'Tilgjengelig',
      diskCount: 'Disker',
      filesystem: 'Filsystem',
      observedAt: 'Observert',
      lostAtRow: 'Erklært tapt den',
      sharedProbeRow: 'Delingsverifisering',
      sharedProbeNodes: 'Sonderte noder',
      reachableFrom: 'Deklarert tilgjengelighet',
      reachableFromHint: 'Nodene denne storagen skal være tilgjengelig fra. En VM med disker, ISO-er eller metadata her verken starter eller migrerer til en node utenfor denne listen. Alle medlemmene er forhåndsvalgt: begrens som du vil. En node som senere blir med i klusteret står utenfor til du legger den til her.',
      reachableFromNone: 'ikke deklarert',
      reachableFromTags: 'Tilgjengelighet per tag',
      reachableFromTagsHint: 'Velger tag=verdi (kommaseparerte oppføringer, AND): hvert medlem som bærer disse taggene erklæres tilgjengelig — dynamisk: tagg en node, og den blir med.',
      reachableFromTagsInvalid: 'Ugyldig format — bruk tag=verdi, kommaseparert',
      reachableResolved: 'Oppløste noder: {nodes}',
      reachableDeclaredNotSeen: 'deklarert men ikke sett av delingssonden på: {nodes}',
      reachableSeenNotDeclared: 'sett men ikke deklarert (utenfor perimeteret) på: {nodes}',
      cephCluster: 'Forvaltet Ceph-kluster',
      appGuardTitle: 'Storage i bruk av Apper',
      appEphemeralGuard: 'denne storagen er Appenes efemere kluster-pool — bytt den først fra App-siden, og slett den så.',
      appInUseGuard: 'her lever app-rooter/-volumer: {apps} — flytt eller slett dem først.',
      releaseRequiredTitle: "Slette '{name}' og frigi bildene dens?",
      releaseRequiredBatchTitle: 'Slette de valgte storagene og frigi bildene deres?',
      releaseRequiredBody: 'Å frigi bildene sletter INGEN byte: avregistreringen lar namespace bli liggende på disken, bildene er rett og slett ikke lenger materialisert, og hver referanse fra scopene overlever som claim — registrer poolen på nytt, så blir de adoptert igjen.',
      releaseConfirm: 'Slett og frigi bildene'
    },
    lost: {
      chip: 'Tapt',
      action: 'Erklær tapt',
      confirmTitle: 'Erklær storagen tapt',
      confirmBody: 'Operatør-attestasjon på egen deklarert risiko: hver task i kø eller i gang på denne storagen eller objektene dens vil FEILE, slettinger blir bare register-slettinger (intet arbeid på filsystemet) og nytt fysisk arbeid avvises. Bytene røres aldri — kommer volumet til live igjen, registrer det på nytt og kjør en scan for å re-adoptere alt.',
      confirmSubmit: 'Erklær tapt',
      error: 'Attestasjonen ble avvist'
    },
    findings: {
      action: 'Funnede objekter',
      title: 'Funnede objekter',
      empty: 'Ingen objekter funnet i storagens namespace',
      loadError: 'Kunne ikke laste de funnede objektene',
      actionError: 'Avgjørelsen ble avvist',
      colKind: 'Type',
      colObject: 'Objekt',
      colConflict: 'Konflikt',
      namespaceNotice:
        'Denne katalogen var allerede initialisert av en annen lagring: identitetsseglet er skrevet over med denne lagringens. Innholdet ble IKKE rørt — se gjennom objektene som ble funnet nedenfor, importer dem du trenger, og avvis deretter denne meldingen.',
      kind: {
        disk: 'Disk',
        catalogFile: 'Katalogfil',
        vmMetadata: 'VM-metadata',
        namespace: 'Namespace',
        foreign: 'Fremmed',
        volumeGroup: 'Volume group'
      },
      vgAdopt: {
        action: 'Adopter volume group',
        title: 'Adopter volume group',
        intro:
          'Denne enheten bærer allerede en volume group med et TVirt-navn, men seglet nevner ingen storage registrert her. Det kan være det en tidligere storage i DETTE clusteret la igjen på LUN-en — eller det ET ANNET TVirt-cluster la igjen på en LUN som har skiftet hender: herfra ser de to tilfellene like ut, og derfor bestemmer ingen for deg.',
        irreversible: 'Se på enheten, seglet og navnet før du fortsetter: adopsjonen kan ikke angres.',
        device: 'Enhet',
        seal: 'Segl',
        sealNone: 'ingen (ingen tvirt.storageId-tagg)',
        renameTo: 'Den får nytt navn',
        renameNone: 'Ingen omdøping: navnet er allerede det denne storagen utleder',
        volumesNote:
          'De inneholdte volumene adopteres IKKE av denne handlingen: neste skann tilbyr dem én om gangen, som vanlige funne objekter.'
      },
      conflictChip: 'ID finnes allerede',
      dismissedChip: 'Ignorert',
      adopt: 'Adopter',
      adoptFileTitle: 'Importer til en katalog',
      adoptFileHint: 'Filer finnes bare inni katalogene: velg målkatalogen for den funnede filen.',
      purge: 'Slett fra disken',
      dismiss: 'Ignorer',
      purgeConfirmTitle: 'Slett fra disken',
      purgeConfirmBody: 'De funnede bytene til {id} blir fjernet fra storagen. Dette kan ikke angres.',
      taskStarted: 'Startet — fortsetter som task i bakgrunnen',
      scan: 'Skann storagen',
      scanStarted: 'Skanning startet…',
      scanDone: 'Skanning fullført — de funnede objektene er oppdatert'
    },
    reinit: {
      action: 'Prøv initialiseringen på nytt'
    },
    wizard: {
      addButton: 'Legg til',
      title: 'Legg til storage',
      back: 'Tilbake',
      continue: 'Fortsett',
      selectHint: 'Velg en protokoll for å se hvordan TVirt bruker den.',
      roadmap: 'Roadmap',
      server: 'Server',
      export: 'Eksportert sti',
      share: 'Share',
      username: 'Brukernavn',
      password: 'Passord',
      passwordHint: 'Write-only: brukt til mounten, vises aldri igjen.',
      credential: 'Legitimasjon',
      credentialManual: 'Skriv inn manuelt',
      credentialHint: 'En keystore-oppføring av typen brukernavn og passord — alternativet til å taste dem her.',
      credentialEmpty: 'Ingen legitimasjon av typen brukernavn og passord i keystoren — opprett den i System → Legitimasjoner, eller tast kontoen nedenfor.',
      options: 'Mount-opsjoner',
      optionsHint: 'Kommaseparert, sendt til mount -o som de er.',
      portal: 'Portal',
      portalHint: 'host[:port] — default port er 3260.',
      target: 'Target-IQN',
      targetHint: 'Navnet på iSCSI-targetet, begynner med iqn.',
      lun: 'LUN',
      wholeLunRow: 'På diskene: denne lagringen navngir bare targetet',
      wholeLunHint: 'Denne lagringen navngir bare targetet: LUN-ene blir disker én om gangen (Opprett disk → overta hel LUN), ingenting skrives på targetet.',
      lunHint: 'LUN-nummeret på targetet — 0 hvis du er i tvil.',
      chapCredential: 'Legitimasjon (CHAP)',
      chapCredentialHint: 'En keystore-oppføring av typen CHAP (iSCSI) brukt ved login — hemmeligheten reiser aldri med storagen.',
      chapNone: 'Ingen autentisering',
      chapEmpty: 'Ingen legitimasjon av typen CHAP (iSCSI) i keystoren — opprett den i System → Legitimasjoner. Uten forblir loginen uautentisert.',
      address: 'Adresse',
      addressHint: 'Host eller IP for NVMe/TCP-targetet (traddr).',
      port: 'Port',
      portHint: 'Targetets TCP-port — 4420 hvis tom.',
      targetNqn: 'Target-NQN',
      targetNqnHint: 'Subsystemets NQN på targetet, begynner med nqn.',
      nsid: 'NSID',
      nsidHint: 'Namespace-ID inni subsystemet — 1 hvis du er i tvil.',
      dhchapCredential: 'Legitimasjon (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'En keystore-oppføring av typen DH-HMAC-CHAP (NVMe) brukt ved tilkoblingen — hemmeligheten reiser aldri med storagen.',
      dhchapNone: 'Ingen autentisering',
      dhchapEmpty: 'Ingen legitimasjon av typen DH-HMAC-CHAP (NVMe) i keystoren — opprett den i System → Legitimasjoner. Uten forblir tilkoblingen uautentisert.',
      monitors: 'Monitorer',
      monitorsHint: 'Endpoints for Ceph-monitorene, host[:port], kommaseparert eller på egne linjer — default port 6789.',
      pool: 'Pool',
      poolHint: 'RBD-poolen som skal konsumeres — ett RBD-bilde per disk.',
      fs: 'Filsystem',
      fsHint: 'Navnet på CephFS-filsystemet (mds_namespace ved mount).',
      fsPath: 'Path inni filsystemet',
      fsPathHint: 'Absolutt path inni filsystemet storagen monterer — / hvis du er i tvil.',
      cephxCredential: 'Legitimasjon (cephx)',
      cephxCredentialHint: 'En keystore-oppføring av typen cephx: username = klientnavn (client.…), secret = base64-nøkkelen. Obligatorisk.',
      cephxNone: 'Ingen cephx-legitimasjon i keystoren — opprett en (type: cephx) i System → Legitimasjoner, eller la et forvaltet Ceph-kluster prege den med "Foreslå som storage".',
      sharedByNature: 'Nettverksstorager er delt av natur: hvert medlem monterer dem på den samme stien forvaltet av TVirt.',
      error: 'Storagen ble avvist',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Annet',
        legacy: 'Legacy'
      },
      legacyHint: 'Støttet fullt ut — vi ville bare ikke valgt dem for en ny installasjon.',
      proto: {
        dir: {
          name: 'Lokal mappe',
          desc: 'En directory på noden: enkelt og raskt. Den er LOKAL for én node, med mindre stien er en virkelig delt share — å merke den delt når den ikke er det koster data.',
          usage: 'TVirt oppbevarer VM-disker, ISO-/diskbilder og templater der.'
        },
        nfs: {
          name: 'NFS',
          desc: 'En NFS-eksport montert av klusteret — delt av natur.',
          usage: 'Huser VM-disker, ISO-/diskbilder og templater.'
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'En Windows/Samba-share montert av klusteret — delt av natur.',
          usage: 'Huser VM-disker, ISO-/diskbilder og templater.'
        },
        sftp: {
          name: 'SFTP',
          desc: 'Et remote filsystem via SSH — uten behov for NAS-eksport.',
          usage: 'I roadmapen.'
        },
        iscsi: {
          name: 'iSCSI',
          desc: 'Blokk-LUN-er via IP med delt LVM oppå.',
          usage: 'Bare disker — ett thin-volum per disk; huser verken ISO-bilder eller templater.'
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Block devices distribuert over et Ceph-kluster.',
          usage: 'Bare disker — ett RBD-bilde per disk, åpnet nativt av QEMU; huser ikke ISO-bilder.'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'Cephs distribuerte filsystem, montert av kjernen på klusteret — shared by nature.',
          usage: 'Huser VM-disker, ISO-/diskbilder og templater — dir-familien på et Ceph-filsystem (cephx-legitimasjon obligatorisk).'
        },
        fc: { name: 'SCSI/FC', desc: 'SCSI-LUN-er over FibreChannel-fabric — den klassiske FC-SAN-en.' },
        fcoe: { name: 'SCSI/FCoE', desc: 'Samme SCSI over FibreChannel, med FC-framene innkapslet i Ethernet.' },
        'iscsi-lun': {
          name: 'iSCSI (hele LUN-er)',
          desc: 'iSCSI-targetet som bærer av hele LUN-er: hver disk ER en LUN, gitt rå til gjesten — ingen LVM imellom.',
          usage: 'Bare disker — én hel LUN per disk, overtatt som den er; SAN-hjemmet for disker med delt skriving.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (hele namespaces)',
          desc: 'NVMe-subsystemet som bærer av hele namespaces: hver disk ER et namespace, gitt rått til gjesten.',
          usage: 'Bare disker — ett helt namespace per disk, overtatt som det er; delt skriving ja, SCSI persistent reservations nei.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'Remote NVMe — ingen SCSI i veien — over enkel TCP, med delt LVM oppå.',
          usage: 'Bare disker — ett thin-volum per disk; huser verken ISO-bilder eller templater.'
        },
        nvmefc: { name: 'NVMe/FC', desc: 'Remote NVMe over FibreChannel-fabric.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe på FibreChannel-fabricen som FCoE frakter inni Ethernet — FCoE- og NVMe/FC-lagene stablet.' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'iSCSI med dataveien flyttet til RDMA — hvilken som helst fabric (InfiniBand, iWARP, RoCE). Forbigått av NVMe/RDMA, fortsatt til stede i arrayer og i ESXi.' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: 'Nativ SCSI over RDMA, æraen før iSER: InfiniBand (med fabric-discovery) og RoCE — overlever i eldre HPC-storager.' },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'Remote NVMe over hvilken som helst RDMA-fabric — InfiniBand, iWARP, RoCE v1 og v2: én enkelt konfigurasjon, det er noden som sier hvilken den har.' },
        s3: { name: 'S3', desc: 'S3-kompatibel object storage — bilder og backuper.' }
      }
    },
    catalogs: {
      title: 'Kataloger',
      createTitle: 'Opprett katalog',
      editTitle: 'Rediger katalog',
      docTitle: 'Katalog',
      notFound: 'Denne katalogen finnes ikke (lenger?)',
      scopeHint: 'Den som leser denne scopen ser (og kan bruke) hver fil i katalogen',
      files: 'Filer',
      noFiles: 'Ingen filer',
      count: {
        iso: 'ISO',
        ctRootfs: 'Tpl CT',
        vmTemplate: 'Tpl VM',
        ociImage: 'OCI',
        firmwareOvmf: 'Firmware'
      },
      systemChip: 'system',
      systemTooltip: 'Systemkatalog: huser plattformens innebygde objekter og kan ikke endres'
    },
    catalogFiles: {
      catalog: 'Katalog',
      kindLabel: 'Type',
      physicalSize: 'Fysisk størrelse',
      virtualSize: 'Virtuell størrelse',
      importTemplateAction: 'Importer som VM Template',
      importTemplateLegacy: 'Ingen deklarert format — brukbar som seed for disker, ikke importerbar',
      importTemplateTitle: 'Importer som VM Template',
      importTemplateSubmit: 'Importer',
      importTemplateError: 'Importen mislyktes',
      importTemplateHint: 'Pakken .tvtpl blir en VM Template: manifestets frosne hardware pluss én disk per entry i arkivet, hver verifisert mot sin checksum. NIC-er og CD/DVD-medier er ikke en del av et arkiv — legg dem til etter importen.',
      importTemplateQcow2Hint: 'En naken qcow2 blir en template med ÉN disk og den deklarerte default-hardwaren: linux-profil, UEFI, 2 vCPU, 2048 MiB, boot fra sin eneste disk. Korriger ved deploy.',
      importTemplateName: 'Templatenavn',
      importTemplateNameHint: 'Tomt = {name} (-import-<n> hvis opptatt)',
      importTemplateStorage: 'Storage for diskene',
      importTemplateMetadataStorage: 'Metadata-storage',
      importTemplateMetadataHint: 'En blokk-storage huser ikke VM-metadataene (firmware, varstore) — velg en dir/nfs/cifs.',
      importTemplateStarted: 'Import startet — templaten dukker opp i fanen Templater når tasken lukkes.',
      kind: {
        iso: 'ISO-bilde',
        'ct-rootfs': 'CT-rootfs',
        'vm-template': 'VM-template',
        'oci-image': 'OCI-bilde',
        'firmware-ovmf': 'OVMF-firmware'
      },
      title: {
        iso: 'ISO-bilder',
        'ct-rootfs': 'CT-templater',
        'vm-template': 'VM-templater',
        'oci-image': 'OCI-bilder',
        'firmware-ovmf': 'OVMF-firmware'
      },
      createTitle: {
        iso: 'Legg til ISO-bilde',
        'ct-rootfs': 'Registrer CT-template',
        'vm-template': 'Legg til VM-template',
        'oci-image': 'Legg til OCI-bilde',
        'firmware-ovmf': 'Legg til OVMF-firmware'
      },
      formatHint: 'Avledet av filendelsen på den valgte filen — korriger det hvis den gjettet feil',
      tarballHint: 'En rootfs-tarball i standard LXC-format (.tar.gz / .tar.xz / .tar.zst / .tar.bz2, eller en enkel .tar)',
      ociArchiveHint: 'En docker-archive-/oci-archive-tarball (.tar eller .tar.gz), for eksempel fra docker save',
      uploadResumeHint: 'Opplasting avbrutt — filen venter på opplasting: send på nytt med samme fil for å gjenoppta',
      moveTitle: 'Flytt fil',
      moveHint: 'To uavhengige dimensjoner: Katalog flytter lenken (samme id, ingen byte flyttes, scope blir målkatalogens); Storage flytter dataene — hver lenkede kopi følger med, avvist mens filen er i bruk. Valgt sammen: først katalogen, så storagen.',
      moveCatalog: 'Målkatalog',
      moveCatalogHint: 'Bare lenken bytter hjem: en VM som har montert filen må kunne se målkatalogen',
      keepCurrent: 'Ikke endre',
      rehomed: 'Lenke flyttet til valgt katalog',
      copyAction: 'Kopier til katalog…',
      copyTitle: 'Kopier til katalog',
      copyLinkHint: 'Kopien er en ny lenke til de samme dataene — ingenting dupliseres på storagen.',
      copyCatalog: 'Målkatalog',
      copyCatalogHint: 'Kopien er måten en fil reiser mellom kataloger på',
      sameCatalog: 'Samme som kilden',
      sharedObjectHint: 'Dataene i denne filen deles av {count} lenkede kopier',
      deleteLastLink: 'Dette er den SISTE lenken til dette innholdet: dataene slettes også fra storagen.',
      deleteLinkOnly: 'Bare denne lenken fjernes — dataene består, fortsatt tilgjengelige fra de andre lenkede kopiene ({count}).',
      noCatalog: 'Det finnes ingen katalog — opprett en',
      inlineCatalogName: 'Katalognavn',
      embeddedChip: 'innebygd',
      embeddedStorage: 'Innebygd i plattformen',
      embeddedNoMove: 'Innebygd plattformfil: den lever ikke på noen storage — klon den i stedet',
      embeddedCopyHint: 'Klonen materialiserer de innebygde bytene på en ekte storage: velg mål-storage og -katalog — kopien er en vanlig fil',
      sourceEmbedded: 'Innebygd i plattformen',
      nodesRow: 'Forekomst per node',
      nodesSummary: '{present} av {total} noder har den',
      nodePresent: 'til stede',
      nodeMissing: 'mangler',
      nodeUnknown: 'ikke rapportert ennå',
      nodesHint: 'Ressursen ligger på disken til hver node (pakken trantor-tvirt-assets): en node uten den kan verken definere en VM med denne fastvaren eller levere Guest Tools. Ulike versjoner på tvers av noder er normalt under en rullerende oppdatering.',
      downloadAction: 'Last ned',
      downloadNotReady: 'Innholdet er ikke klart ennå — nedlastingen krever en ready fil',
      downloadDenied: 'Rollen din inkluderer ikke catalog.download — å laste ned bytene er en rett adskilt fra bruken av filen',
      objectRow: 'Storage-objekt',
      objectLinksRow: 'Lenkede kopier',
      declaredChecksum: 'Deklarert SHA-256',
      usedByRow: 'Brukt av',
      usedByVms: 'VM-er',
      usedByDisks: 'Disker',
      transferRow: 'Overføring',
      storageLockHint: 'Endres bare med handlingen Flytt'
    },
    objects: {
      action: 'Utforsk innholdet',
      title: 'Storagens innhold',
      hint: 'Read-only-oversikt over hva som lever på denne storagen — hvert objekt forvaltes fra sin egen seksjon.',
      empty: 'Ingen objekter registrert på denne storagen',
      loadError: 'Kunne ikke laste innholdet',
      colDetail: 'Detalj',
      manage: 'Forvalt i seksjonen sin',
      kind: {
        disk: 'Disk',
        catalogFile: 'Katalogfil',
        ociBlob: 'OCI-blob',
        checkpoint: 'Checkpoint',
        vmMetadata: 'VM-metadata',
        appRoot: 'App-root',
        appVolume: 'App-volum'
      }
    },
    inventory: {
      tabCatalogs: 'Kataloger',
      storage: 'Storage',
      sizeGib: 'Størrelse (GiB)',
      format: 'Format',
      size: 'Størrelse',
      sourceType: 'Kilde',
      sourceFile: 'Filopplasting',
      sourceUrl: 'Nedlasting fra URL',
      file: 'Fil',
      url: 'URL',
      checksum: 'SHA-256-checksum',
      checksumHint: 'Obligatorisk: nedlastingen verifiseres mot denne SHA-256',
      verifyChecksum: 'Verifiser checksum',
      checksumOffHint: 'Nedlastingen aksepteres uten verifisering — den beregnede SHA-256 registreres likevel',
      uploading: 'Laster opp…',
      move: {
        action: 'Flytt',
        diskTitle: 'Flytt disk',
        target: 'Mål-storage',
        diskHint: 'Disken beholder identiteten sin: bytene reiser til den valgte storagen. En VM som bruker den må være avslått; med snapshots til stede avviser en iSCSI-side flyttingen.',
        noTargets: 'Ingen kompatibel mål-storage',
        submit: 'Flytt',
        error: 'Flyttingen ble avvist'
      },
      clone: {
        action: 'Klon',
        title: 'Klon disk',
        name: 'Navn på kopien',
        storage: 'Mål-storage',
        sameStorage: 'Samme som kilden',
        linked: 'Linked clone',
        linkedHint: 'Umiddelbart qcow2-overlay lenket til kildedisken (bare qcow2-kilder). Default er en full kopi.',
        linkedCrossHint: 'En linked clone blir på kildens storage: velg "Samme som kilden" for å aktivere den.',
        submit: 'Klon',
        error: 'Kloningen ble avvist'
      },
      copy: {
        action: 'Kopier',
        name: 'Navn på kopien',
        storage: 'Mål-storage',
        sameStorage: 'Samme som kilden',
        submit: 'Kopier',
        error: 'Kopieringen ble avvist'
      },
      taskStarted: 'Startet — fortsetter som task i bakgrunnen',
      cephObjects: 'Gå til objektdetaljene på Ceph',
      phase: {
        ready: 'Klar',
        creating: 'Opprettes',
        'awaiting-upload': 'Venter på opplasting',
        downloading: 'Lastes ned',
        verifying: 'Verifiseres',
        deleting: 'Slettes',
        error: 'Feil',
        'in-use': 'I bruk'
      }
    }
  }
}
